import smoothScroll from 'smooth-scroll';
let options = { 
  speed: 500,
  //offset: window.innerWidth >= 768 ? 0 : 50
  offset: 50
};

//console.log(options);
let scroll = new smoothScroll('a[href*="#spot01"],a[href*="#spot03"],a[href*="#spot05"]', options);


let options2 = { 
  speed: 500,
  offset: window.innerWidth >= 768 ? 0 : 50
};

let scroll2 = new smoothScroll('a[href*="#spot02"],a[href*="#spot04"]', options2);



// var hash = location.hash;

// if ($(hash).length > 0) {
//   $(window).scrollTop(0);
//   setTimeout(function () {
//     scroll.animateScroll(document.querySelector(target), options);
//   }, 700);
// }